export type AudioRecorderControls = {
  /** Start recording. Optionally pass a session ID to resume from OPFS. */
  start?: (resumeSessionId?: string) => void;
  stop?: () => void;
  pause?: () => void;
  resume?: () => void;
  /**
   * Clear recording state.
   *
   * @param deleteOpfsSession - If true (default), deletes the OPFS session.
   *   Pass false for success flow where handleRecordingComplete needs the session.
   */
  clear?: (deleteOpfsSession?: boolean) => void;
};

export const getAudioRecorder = (): AudioRecorderControls =>
  (window as any).__audioRecorder ?? {};
